import { Menus, MenuItemIds } from "components/HeaderExtra/Constants";
import { SelectedContent } from "components/HeaderExtra/Components/USCMenu/interface";
import _, { isArray } from "lodash";
import { ITemplate } from "interfaces/Templates";
import { DocumentType } from "constants/TemplateEditor";

/**
 * @description Get menu content by selected id.
 * @param {MenuItemIds} id - Selected id
 * @returns - Selected content
 */
export const getContentByMenuId = (id: MenuItemIds): SelectedContent => {
  try {
    const content = _.find(Menus, { id });
    if (content) {
      return content;
    } else {
      return Menus[0];
    }
  } catch (error) {
    return Menus[0];
  }
};

/**
 * @description Get menu content by selected id.
 * @param {any[]} groups - Group list
 * @param {string | null} groupId - Selected template group id
 * @returns {string} - Selected template group name
 */
export const getTemplateGroupId = (
  groups: any[],
  groupName: string | null
): string => {
  try {
    if (isArray(groups)) {
      const group = groups.find((group) => group.groupName == groupName);
      return group?.groupId ?? "";
    } else {
      return "";
    }
  } catch (error) {
    return "";
  }
};

/**
 * @description check the validity of the imported template
 * @param {any} templateFile - imported template
 * @param {number} mainAdapterId - current main adapter id
 * @param {number} templateCategoryId - current template category id
 * @returns {boolean} - valid/invalid
 */
export const isValidTemplateFile = (
  templateFile: any,
  mainAdapterId: number,
  templateCategoryId: number
): boolean => {
  try {
    if (templateFile) {
      return (
        templateFile?.templateContent?.adapter?.mainAdapterId !=
          mainAdapterId || templateFile?.categoryId != templateCategoryId
      );
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

/**
 * @description Check the validity of the the current template
 * @returns {boolean}
 */
export const isValidTemplate = (): boolean => {
  try {
    const repeatingElements = document.querySelectorAll(
      "tr[id=repeatingcontent]"
    );
    let isValid = true;
    if (repeatingElements && repeatingElements.length > 0) {
      repeatingElements.forEach((repeatingElement, index) => {
        if (
          !repeatingElement.hasAttribute("repeatingadapterid") ||
          (repeatingElement.hasAttribute("repeatingadapterid") &&
            repeatingElement.getAttribute("repeatingadapterid") == "0")
        ) {
          isValid = false;
        }
      });
      return isValid;
    } else {
      return true;
    }
  } catch (error) {
    return false;
  }
};

/**
 * @description returns if the template name changed or not
 * @param {ITemplate} currentTemplate - current template
 * @param {Array<ITemplate>} templateList - template list
 * @returns {boolean} - template name changed or not
 */
export const isTemplateNameChanged = (
  currentTemplate: ITemplate,
  templateList: Array<ITemplate>
): boolean => {
  try {
    if (isArray(templateList) && currentTemplate.templateId) {
      const template = templateList.find(
        (template) => template.templateId == currentTemplate.templateId
      );
      if (template) {
        return template.templateName != currentTemplate.templateName;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

/**
 * @description Deside the output document format from the category and selected document type
 * @param {string} categoryName - Current selected category name
 * @param {DocumentType} selectedDocumentType - Current selected document type
 * @returns {DocumentType} - Output document type
 */
export const getTemplateDocumentFormat = (
  categoryName: string,
  selectedDocumentType: DocumentType
): DocumentType => {
  try {
    if (categoryName == "SMS") {
      return DocumentType.SMS;
    } else if (categoryName == "EHF") {
      return DocumentType.EHF;
    } else {
      const format =
        selectedDocumentType == DocumentType.ALL
          ? DocumentType.PDF
          : selectedDocumentType;
      return format;
    }
  } catch (error) {
    return DocumentType.PDF;
  }
};

/**
 * @description Get main adapter id for the selected group and category
 * @param {any[]} groups - Group list
 * @param {number} groupId - Selected template group id
 * @param {number} groupId - Selected template group id
 * @returns {number} - Selected template group name
 */
export const getTemplateMainAdapterId = (
  groups: any[],
  groupId: string | null | undefined,
  catergoryId: string | null | undefined
): number => {
  try {
    if (isArray(groups)) {
      const groupIndex = groups.findIndex((group) => group.groupId == groupId);
      if (groupIndex > -1) {
        const categoryIndex = groups[groupIndex].categories.findIndex(
          (category: { categoryId: string }) =>
            category.categoryId == catergoryId
        );
        if (categoryIndex > -1) {
          if (
            groups[groupIndex].categories[categoryIndex].templates.length > 0
          ) {
            return groups[groupIndex].categories[categoryIndex].templates[0]
              .mainAdapterId;
          }
        }
      }
      return 0;
    } else {
      return 0;
    }
  } catch (error) {
    return 0;
  }
};
